import { textStyles, colors, loadingDark, loadingLight } from '../../shared/styles';

export const styles = {
  scheduleContainer: (fetching) => ({
    position: 'relative',
    minHeight: (fetching) ? 245 : 0,
    marginBottom: 37,
  }),
  title: {
    marginBottom: 26, 
    ...textStyles.sectionHead,
  },

  dateWrapper: {
    marginBottom: 17,
  },
  date: {
    marginBottom: 5,
    ...textStyles.body1Dark,
  },

  disclaimer: {
    fontSize: 12,
    color: colors.grey,
  },

  loadingContainer: (show) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    pointerEvents: 'none',
    opacity: (show) ? 1 : 0,
    transition: 'opacity 0.3s',
  }),
  loadingTitle: {
    width: '50%',
    height: 12,
    marginBottom: 28,
    pointerEvents: 'none',
    ...loadingDark,
  },
  loadingDate: {
    width: '40%',
    height: 14,
    marginBottom: 20,
    pointerEvents: 'none',
    ...loadingLight,
  },
  loadingTime: {
    width: '80%',
    height: 16,
    marginBottom: 29,
    pointerEvents: 'none',
    ...loadingLight,
  },
};
